
window.addEventListener("DOMContentLoaded", (event) => {
console.log('✅');


/* Click on headers - list view */
const resourceHeaders = document.querySelectorAll(".list .ifResourcesTitle, .list .resourceThumb, .list .resourceInnerBlock");
resourceHeaders.forEach(function(el) {

 el.addEventListener("click", function() { 
  const parnt = el.closest(".ifResSingleItem");
  if (parnt) {
    const detals = parnt.querySelector("details");
    if (detals) {
        /* (detals.open) ? detals.open = false : detals.open = true;*/
        if (detals.open == false) {
          detals.open = true;
        }
        else {
          detals.open = false;

        }
    }
  }
 });
});

const resourceHeadersCards = document.querySelectorAll(".cards .ifResourcesTitle, .cards .resourceThumb, .cards .resourceInnerBlock");
resourceHeadersCards.forEach(function(el) {

 el.addEventListener("click", function() { 
  const parnt = el.closest(".ifResSingleItem");
  if (parnt) {
    
    const dilog = parnt.querySelector("dialog");

    if (dilog) {
      
      dilog.showModal();     

    }

  }
 });
});

/**  List view - open dialog **/
const dialogBtns = document.querySelectorAll(".dialogOutputsMore");
dialogBtns.forEach(function(el) {
  let identifier= el.data
  el.addEventListener("click", function() {
    let identifier= el.dataset.identifier;
    document.getElementById("dialog"+identifier).showModal();

    let detailsClicked = new IfResourceEvent('ifpri_res_details_click', identifier, null);
    detailsClicked.sendEvent();

  });
  
})



/*------------------------------------------*/
/* Citation - copy to clipboard             */
/*------------------------------------------*/

let citationElms = document.querySelectorAll('.citationDisplay');
citationElms.forEach((citationElm) => {
  //console.log('one found');
  citationElm.addEventListener('click', function(e) {
    let citationText = citationElm.textContent;
    const copied = copyTextToClipboard(citationText)





    if (copied) {
    
      let spanDiv = citationElm.querySelector('span')
      if (spanDiv) {
        spanDiv.classList.remove('dashicons-plus-alt')
        spanDiv.classList.add('dashicons-yes-alt')
        setTimeout(
          function() {
            spanDiv.classList.remove('dashicons-yes-alt')
            spanDiv.classList.add('dashicons-plus-alt')
        }, 2500);
      }

    let identifier= citationElm.dataset.identifier;
    let citationClicked = new IfResourceEvent('ifpri_res_citation_item', identifier);
    citationClicked.sendEvent();
  }
  })

})

async function copyTextToClipboard(textToCopy) {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(textToCopy);
      return true;
    }
  } catch (err) {
    console.error(err);
    return false;
  }
}



  /*-----------------Details buttons -------------------*/
  const publicationsDetails =  document.querySelectorAll('.ifpriResourcesItemBlock summary.outputDetails, .ifpriResourcesItemBlock .ifResourcesTitle, .ifpriResourcesItemBlock .resourceThumb')
  publicationsDetails.forEach(function(pubDetailBtn) {
    pubDetailBtn.addEventListener('click', function(detBtn) {

      let identifier= pubDetailBtn.dataset.identifier;
      let resultsDiv;
      let detailsClicked = new IfResourceEvent('ifpri_res_details_click', identifier);
      detailsClicked.sendEvent();
  

    })

  })


  /*--------------- Download Buttons --------------------*/
 const publicationsDLd =  document.querySelectorAll('.ifpriResourcesItemBlock .resourceDownloadBtn')
 publicationsDLd.forEach(function(pubDldBtn) {
  pubDldBtn.addEventListener('click', function(dldBtn) {

      let identifier= pubDldBtn.dataset.identifier;
      let resultsDiv;
      let downloadClicked = new IfResourceEvent('ifpri_res_download', identifier);
      downloadClicked.sendEvent();
  

    })

  })


     /*--------------- Source Buttons --------------------*/
     const publicationsSoruce =  document.querySelectorAll('.ifpriResourcesItemBlock .ifeb_res_source')
     publicationsSoruce.forEach(function(pubSourceBtn) {
       pubSourceBtn.addEventListener('click', function(dldBtn) {
    
          let identifier= pubSourceBtn.dataset.identifier;
          let resultsDiv;
          let downloadClicked = new IfResourceEvent('ifpri_res_source', identifier);
          downloadClicked.sendEvent();
      
    
        })
    
      })
     /*--------------- DOI Buttons --------------------*/
     const publicationsDOIs =  document.querySelectorAll('.ifpriResourcesItemBlock .ifeb_res_doi')
     publicationsDOIs.forEach(function(pubDOI) {
       pubDOI.addEventListener('click', function(dldBtn) {
    
          let identifier= pubDOI.dataset.identifier;
          let resultsDiv;
          let downloadClicked = new IfResourceEvent('ifpri_res_doi', identifier);
          downloadClicked.sendEvent();
      
    
        })
    
      })


/******************************************************************************************************/
/*  Events to send to Google Analytics                                                                */
/*  Example:                                                                                          */
/*    let detailsClicked = new IfResourceEvent('Details clicked', record.handle, resultsDiv);         */
/*    detailsClicked.sendEvent();                                                                     */
/******************************************************************************************************/

function IfResourceEvent(evtTitle, handle, resultsDiv, redirectURL="N/A") {
	const url = new URL(window.location);
	this.handle = handle;
	this.evtTitle = evtTitle;
	this.redirect_url = redirectURL;
	this.url = url;
	this.gid = "G-9ET431M2SQ";
	/* used for reporting... */
	this.resultsDiv = resultsDiv;
  }
  
  IfResourceEvent.prototype.sendEvent = async function () {
  
	window.dataLayer = window.dataLayer || [];
	function gtag() { dataLayer.push(arguments); }
	gtag('js', new Date());
	gtag('config', this.gid, {
	  send_page_view: false
	});
	if(this.redirect_url !=="N/A") {
	  gtag('event', this.evtTitle, {
		resource_handle: this.handle,
		resource_query: this.url.search,
		resource_redirect: this.redirect_url,
		send_to: this.gid
	  })
	}
  
	else {
	  gtag('event', this.evtTitle, {
		resource_handle: this.handle,
		resource_query: this.url.search,
		send_to: this.gid
	  })
  
	}
  
	const message = `Type: ${this.evtTitle}, Record:  ${this.handle}, Gid:  ${this.gid},  ${this.url.search !=="" ? ", URL search : " + this.url.search : ""} `;
	console.log(message);
	if (this.resultsDiv) {
	 // appendAdminAnalytics(this.resultsDiv, message);
	}
  
	return true;
  }
  
  function appendAdminAnalytics(resultsDiv, message) {
  
	const adminSection = resultsDiv.nextElementSibling;
	if (adminSection) {
	  const adminSectionAnalytics = adminSection.querySelector('.admininAnalytics');
	  if (adminSectionAnalytics) {
			adminSectionAnalytics.append(createCustomElement("p", { "class": ["adminAnalyticsMsg"] }, {}, message));
	  }
  
	}
  
  }

});